import React, { useState, useEffect } from 'react'
import Card from '../../components/Card.jsx'
import * as api from '../../services/api.js'
import AppSelect from '../../components/AppSelect.jsx'

const CATEGORIES = ['Produce', 'Meat & Fish', 'Dairy', 'Bakery', 'Pantry', 'Frozen', 'Other']
const CATEGORY_OPTIONS = CATEGORIES.map(c => ({ value: c, label: c }))

export default function CookingShoppingList() {
  const [items, setItems] = useState([])
  const [draft, setDraft] = useState({ name: '', amount: '', category: 'Produce' })

  useEffect(() => { api.getShoppingList().then(d => setItems(d || [])) }, [])

  function updateItems(updater) {
    setItems(prev => {
      const next = typeof updater === 'function' ? updater(prev) : updater
      api.saveShoppingList(next)
      return next
    })
  }

  function addItem() {
    if (!draft.name.trim()) return
    updateItems(prev => [...prev, { id: Date.now(), ...draft, done: false }])
    setDraft(d => ({ ...d, name: '', amount: '' }))
  }

  function toggle(id) {
    updateItems(prev => prev.map(i => i.id === id ? { ...i, done: !i.done } : i))
  }

  function deleteItem(id) {
    updateItems(prev => prev.filter(i => i.id !== id))
  }

  function clearDone() {
    updateItems(prev => prev.filter(i => !i.done))
  }

  function clearAll() {
    updateItems([])
  }

  const byCategory = CATEGORIES.map(cat => ({
    cat,
    catItems: items.filter(i => i.category === cat),
  })).filter(g => g.catItems.length > 0)

  const doneCount = items.filter(i => i.done).length

  return (
    <Card label="Cooking" title="Shopping List">
      <div className="cook-form" style={{ marginBottom: '1rem' }}>
        <div>
          <label className="field-label">Item</label>
          <input
            className="field-input"
            value={draft.name}
            onChange={e => setDraft(d => ({ ...d, name: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && addItem()}
            placeholder="e.g. Cherry tomatoes"
          />
        </div>
        <div>
          <label className="field-label">Amount</label>
          <input
            className="field-input"
            value={draft.amount}
            onChange={e => setDraft(d => ({ ...d, amount: e.target.value }))}
            placeholder="e.g. 500g"
          />
        </div>
        <div>
          <label className="field-label">Category</label>
          <AppSelect
            value={draft.category}
            onChange={v => setDraft(d => ({ ...d, category: v }))}
            options={CATEGORY_OPTIONS}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <button
            className={`save-btn ${draft.name.trim() ? 'ready' : ''}`}
            onClick={addItem}
          >
            Add Item
          </button>
        </div>
      </div>

      {items.length > 0 && (
        <div style={{ display: 'flex', gap: '8px', marginBottom: '1rem', flexWrap: 'wrap' }}>
          {doneCount > 0 && (
            <button className="ghost-btn" onClick={clearDone}>
              Remove checked ({doneCount})
            </button>
          )}
          <button className="ghost-btn" onClick={clearAll}>Clear all</button>
          <span style={{ fontSize: '0.78rem', color: 'var(--stone)', alignSelf: 'center', marginLeft: 'auto' }}>
            {doneCount}/{items.length} done
          </span>
        </div>
      )}

      {items.length === 0 ? (
        <p style={{ color: 'var(--stone)', fontStyle: 'italic', fontSize: '0.88rem' }}>
          Your shopping list is empty. Add items above, or use "+ Shopping list" on a recipe card.
        </p>
      ) : (
        byCategory.map(({ cat, catItems }) => (
          <div key={cat}>
            <p className="shopping-cat-label">{cat}</p>
            {catItems.map(item => (
              <div key={item.id} className={`task-item${item.done ? ' task-item--done' : ''}`}>
                <button
                  className="task-item__checkbox"
                  onClick={() => toggle(item.id)}
                />
                <span className="task-item__text">
                  {item.name}
                  {item.amount && <span className="shopping-amount" style={{ marginLeft: '0.5rem', fontSize: '0.75rem', color: 'var(--stone)' }}>{item.amount}</span>}
                </span>
                <div className="task-item__actions">
                  <button
                    className="task-item__action-btn task-item__action-btn--danger"
                    onClick={() => deleteItem(item.id)}
                    title="Delete"
                  >✕</button>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
    </Card>
  )
}
